const colors = {
  colorAlert: (opacity = 1) => `rgba(255, 92, 102, ${opacity})`,
  colorLight: "#E6E6E6",
  colorLightGreen: (opacity = 1) => `rgba(222, 255, 151, ${opacity})`,
  colorInfo: (opacity = 1) => `rgba(146, 221, 255, ${opacity})`,
  colorPrimary: (opacity = 1) => `rgba(112, 112, 112, ${opacity})`,
  colorWhite: (opacity = 1) => `rgba(251, 251, 251, ${opacity})`,
  colorGray: (opacity = 1) => `rgba(112, 112, 112, ${opacity})`,
  colorGrayLight: (opacity = 1) => `rgba(230, 230, 230, ${opacity})`,
  colorBlack: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
};

const spacing = {
  defaultSpacing: (n = 1) => `${8 * n}px`,
};

const radius = {
  defaultRadius: "2px",
  oval: "50px",
};

const fonts = {
  fontFamilyDefault: '"GalaxieCopernicus", serif',
  fontFamilyHeaders: '"NHaasGrotesk", serif',
  h2: "24px",
  h3: "18px",
  sizeBase: "16px",
  sizeMedium: "14px",
  sizeSmall: "12px",
  fontLight: 300,
  fontMedium: 400,
  fontBold: 600,
  lineHeight: "26px",
  lineHeightSmall: "19px",
};

const transitions = {
  transitionDefault: "300ms ease",
};

const paths = {
  imagePath: (path: string) => `/assets/images/${path}`,
};

const breakpoints = {
  huge: "1440px",
  large: "1170px",
  medium: "768px",
  small: "450px",
};

export { colors, spacing, radius, fonts, transitions, paths, breakpoints };

export interface ThemeProps {
  colors: typeof colors;
  spacing: typeof spacing;
  radius: typeof radius;
  fonts: typeof fonts;
  transitions: typeof transitions;
  paths: typeof paths;
  breakpoints: typeof breakpoints;
}
